import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";

function Compensations() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default Compensations;
